import * as moment from 'moment';
import { tdb as db } from '../database';
import { encrypt_item, decrypt_item } from '../support/crypt';
export const TopicCacheRecordSchema = '[key+version+language], accessed';
export class TopicCacheRecord {
    key;
    version;
    language;
    topic;
    related;
    accessed;
    constructor(key, version, language, topic, related, accessed) {
        this.key = key;
        this.version = version;
        this.language = language;
        this.topic = topic;
        this.related = related;
        this.accessed = accessed;
    }
    async save() {
        this.accessed = moment().toISOString();
        await db.topiccache.put(this);
    }
    age() {
        const { accessed } = this;
        if (accessed) {
            const now = moment();
            const old = moment(accessed);
            return now.diff(old, 'hours');
        }
        return 0;
    }
}
export async function get_topic({ key, version, language, topic_getter, related_getter }) {
    let record = await db.topiccache.where({ key, version, language }).first();
    if (record === undefined) {
        const topic = await topic_getter({ key, version, language });
        const related = related_getter ? await related_getter({ key, version, language }) : [];
        record = new TopicCacheRecord(key, version, language, await encrypt_item(topic), related);
    }
    record.save();
    const topic = await decrypt_item(record.topic);
    return topic;
}
export async function get_related({ key, version, language, related_getter }) {
    const record = await db.topiccache.where({ key, version, language }).first();
    if (record === undefined) {
        const related = await related_getter({ key, version, language });
        return related;
    }
    else if (record.related.length === 0) {
        record.related = await related_getter({ key, version, language });
        record.save();
    }
    return record.related;
}
export async function precache_topics({ keys, version, language, topic_getter, related_getter }) {
    const alltopics = keys.map(async (key) => {
        let record = await db.topiccache.where({ key, version, language }).first();
        if (record === undefined) {
            const topic = await topic_getter({ key, version, language });
            const related = await related_getter({ key, version, language });
            record = new TopicCacheRecord(key, version, language, await encrypt_item(topic), related);
            record.save();
        }
        return record;
    });
    return await Promise.all(alltopics);
}
export async function has_topic({ key, version, language }) {
    const record = await db.topiccache.where({ key, version, language }).first();
    return record !== undefined;
}
